import { LorenMeteringType } from "../interfaces/loren-metering-type";

export enum LorenMeteringContext {
  DOOR_WINDOW = "DOOR_WINDOW",
  VEHICLE_IGNITION = "VEHICLE_IGNITION",
  SMOKE = "SMOKE",
  TILT = "TILT",
  WATER_LEAK = "WATER_LEAK",
  MOVEMENT = "MOVEMENT",
  STATE = "STATE",
}

export const METERING_CONTEXT_TRANSLATION_NAMES: Map<
  LorenMeteringContext,
  string
> = new Map<LorenMeteringContext, string>([
  [LorenMeteringContext.DOOR_WINDOW, "asset.metering_context_door_window"],
  [
    LorenMeteringContext.VEHICLE_IGNITION,
    "asset.metering_context_vehicle_ignition",
  ],
  [LorenMeteringContext.SMOKE, "asset.metering_context_smoke"],
  [LorenMeteringContext.TILT, "asset.metering_context_tilt"],
  [LorenMeteringContext.WATER_LEAK, "asset.metering_context_water_leak"],
  [LorenMeteringContext.MOVEMENT, "metering_type.movement"],
  [LorenMeteringContext.STATE, "asset.metering_context_state"],
]);

export const METERING_CONTEXT_SHOW_FIELD_MAP: Map<LorenMeteringType, boolean> =
  new Map<LorenMeteringType, boolean>([
    [LorenMeteringType.BINARY_SENSOR, true],
    [LorenMeteringType.DOOR_WINDOW_BINARY_SENSOR, true],
    [LorenMeteringType.IGNITION_BINARY_SENSOR, true],
    [LorenMeteringType.SMOKE_BINARY_SENSOR, true],
    [LorenMeteringType.TILT_BINARY_SENSOR, true],
    [LorenMeteringType.WATER_LEAK_BINARY_SENSOR, true],
    [LorenMeteringType.PIR_BINARY_SENSOR, true],
  ]);
